<template>
  <ScreenWrapper>
    <Transition name="slide-fade" mode="out-in">
      <ScreenSuccess class="mx-2" v-if="isSuccessVisible">
        <template #heading>
          <h2 class="text-white text-2xl font-semibold leading-8">
            Report submitted!
          </h2>
        </template>
        <template #cta>
          <BaseButton
            @click="hideSuccessScreen"
            class="text-primary text-base leading-6"
            >Close</BaseButton
          >
        </template>
      </ScreenSuccess>
      <section v-else class="md:max-w-6xl mx-auto px-4 md:px-0">
        <div class="flex flex-col">
          <div
            class="flex flex-col md:flex-row items-center justify-between pt-8 mb-16"
          >
            <h1 class="text-white text-[32px] md:text-[40px] font-semibold">
              Report new vulnerability
            </h1>
            <BaseLink
              to="https://patchstack.com/academy/general/submitting-a-report/"
              target="_blank"
              class="text-primary hover:bg-soft-frost hover:bg-opacity-10 px-2 py-1 rounded-sm"
              >See guidelines</BaseLink
            >
          </div>
        </div>
        <ReportCreateForm is-public @report-created="showSuccessScreen" />
      </section>
    </Transition>
  </ScreenWrapper>
</template>

<script setup lang="ts">
  import { useSuccessScreen } from '@/composables';
  definePageMeta({
    layout: 'base'
  });
  useSeoMeta({
    title: 'Database - Create Report'
  });
  const { isSuccessVisible, showSuccessScreen, hideSuccessScreen } =
    useSuccessScreen();
</script>
